import React, { useState } from "react";
import styled from "@emotion/styled/macro";
import { Manager, Reference, Popper } from "react-popper";
import { withProps } from "recompose";
import { isMobile } from "react-device-detect";

import hint from "../../../assets/images/hint.svg";

const Trigger = styled.div`
  color: ${({ theme }) => theme.colors.opal};
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.opal};
  border-radius: 15px;
  display: inline-flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 18px;
  height: 18px;
  font-size: 15px;
  line-height: 15px;
  padding-top: 1px;
`;
const Text = styled.div`
  color: ${({ theme }) => theme.colors.opal};
  display: inline-flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 15px;
  line-height: 15px;
  text-decoration: underline;
`;
const Tooltip = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  border: 3px solid ${({ theme }) => theme.colors.powder};
  background: ${({ theme }) => theme.colors.cultered};
  box-shadow: 2px 2px 5px ${({ theme }) => theme.colors.opal};
  color: ${({ theme }) => theme.colors.primary};
  font-size: 1rem;
  line-height: 1.1rem;
  z-index: 10;
  border-radius: 10px;
  max-width: 300px;
  white-space: normal;
  &[data-placement*="top"] {
    margin-bottom: 5px;
  }
  &[data-placement*="bottom"] {
    margin-top: 5px;
  }
  &[data-placement*="right"] {
    margin-left: 5px;
  }
  &[data-placement*="left"] {
    margin-right: 5px;
  }
`;
const Title = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.lg};
  font-weight: bold;
  padding-bottom: 1em;
`;

const Info = withProps({ src: hint })(styled.img`
  height: 16px;
  margin: 0 2px -2px;
`);

const CloseWrapper = styled.div`
`;

const Hint = ({ text, info, noMargin, title, children }) => {
  const [isShown, setShown] = useState(false);

  const onMouseOver = () => {
    if (!isMobile) {
      show();
    }
  };
  const onMouseLeave = () => {
    if (!isMobile) {
      hide();
    }
  };
  const show = () => {
    setShown(true);
  };
  const hide = () => {
    setShown(false);
  };
  const toggle = () => {
    setShown(!isShown);
  };

  return (
      <Manager>
        <Reference>
          {({ ref }) => [
            info && !text && (
              <Info
                ref={ref}
                onClick={toggle}
                onMouseOver={onMouseOver}
                onMouseLeave={onMouseLeave}
                close={isShown}
              />
            ),
            text && (
              <Text
                ref={ref}
                onClick={toggle}
                onMouseOver={onMouseOver}
                onMouseLeave={onMouseLeave}
                close={isShown}
              >
                {text}
              </Text>
            ),

            !info && !text && (
              <Trigger ref={ref} 
              onClick={toggle} 
              onMouseOver={onMouseOver} 
              onMouseLeave={onMouseLeave}>
                {isShown ? <CloseWrapper>x</CloseWrapper> : "?"}
              </Trigger>
            ),
          ]}
        </Reference>
        {isShown && (
          <Popper placement="auto">
            {({ ref, style, placement }) => (
              <Tooltip ref={ref} style={style} data-placement={placement}>
                <Title>{title}</Title>
                {children}
              </Tooltip>
            )}
          </Popper>
        )}
      </Manager>
  );
};
export default Hint;
